import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export const NewsletterSignup = ({ variant = "full" }) => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      const { data } = await api.post("/newsletter/subscribe", { email, name });
      setDone(true);
      toast.success(data.already ? "Already on the list, ma chère." : "Welcome to the letter.");
    } catch {
      toast.error("Something went wrong. Try again?");
    } finally {
      setBusy(false);
    }
  };

  if (variant === "compact") {
    return (
      <div data-testid="newsletter-compact" style={{ padding: 24, border: "1px solid var(--border-default)", background: "var(--surface)" }}>
        <div className="overline" style={{ color: "var(--brand-accent)" }}>The Editor&apos;s Journal</div>
        <p className="font-serif" style={{ fontSize: 22, fontStyle: "italic", marginTop: 8, marginBottom: 16, lineHeight: 1.3 }}>
          Sundays, by post.
        </p>
        {done ? (
          <p style={{ fontSize: 14, color: "var(--text-secondary)", margin: 0 }}>
            See you Sunday. Watch your inbox.
          </p>
        ) : (
          <form onSubmit={submit}>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email"
              data-testid="newsletter-email-compact"
              className="input-belle"
              style={{ marginBottom: 14 }}
            />
            <button type="submit" disabled={busy} className="btn-primary" style={{ width: "100%" }} data-testid="newsletter-submit-compact">
              {busy ? "…" : "Subscribe"}
            </button>
          </form>
        )}
      </div>
    );
  }

  return (
    <section data-testid="newsletter-full" style={{ background: "var(--bg-alt)", padding: "96px 0", marginTop: 80, borderTop: "1px solid var(--border-default)" }}>
      <div className="container-belle" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 80, alignItems: "center" }}>
        <div>
          <div className="overline" style={{ color: "var(--brand-accent)" }}>Sundays, by post</div>
          <h2 className="editorial-h1" style={{ fontSize: "clamp(36px, 5vw, 60px)", marginTop: 14, marginBottom: 22 }}>
            Have the letter delivered.
          </h2>
          <p className="editorial-body" style={{ fontSize: 17, marginBottom: 8 }}>
            A short, beautiful Sunday letter from the editor — featuring the week's most-loved photographs and essays from the salon. Free, of course. Unsubscribe with a click.
          </p>
        </div>

        <div style={{ background: "var(--surface)", border: "1px solid var(--border-default)", padding: 40 }}>
          {done ? (
            <div style={{ textAlign: "center", padding: "24px 0" }}>
              <div className="overline" style={{ color: "var(--brand-accent)" }}>Merci ✓</div>
              <p className="font-serif" style={{ fontSize: 28, fontStyle: "italic", lineHeight: 1.35, marginTop: 14, marginBottom: 0 }}>
                See you Sunday.<br />Watch your inbox.
              </p>
            </div>
          ) : (
            <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 24 }}>
              <div>
                <label className="overline">Your first name (optional)</label>
                <input
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Amélie"
                  data-testid="newsletter-name-input"
                  className="input-belle"
                />
              </div>
              <div>
                <label className="overline">Email</label>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@belleinspiration.com"
                  data-testid="newsletter-email-input"
                  className="input-belle"
                />
              </div>
              <button type="submit" disabled={busy} className="btn-primary" data-testid="newsletter-submit-button" style={{ marginTop: 8 }}>
                {busy ? "Subscribing…" : "Subscribe to the letter"}
              </button>
              <p className="overline" style={{ opacity: 0.6, fontSize: 11 }}>
                One letter per week. Never shared. Unsubscribe anytime.
              </p>
            </form>
          )}
        </div>
      </div>
      <style>{`
        @media (max-width: 800px) {
          [data-testid="newsletter-full"] .container-belle { grid-template-columns: 1fr !important; gap: 40px !important; }
        }
      `}</style>
    </section>
  );
};
